import { adt, eq, iots, string } from '@code-expert/prelude';
import { eqQuizGradingSettings, QuizGradingSettings } from './QuizGradingSettings';

const orderKeys = {
  manual: null,
  random: null,
};

export const QuizSettingOrderC = iots.keyof(orderKeys);

type QuizSettingOrder = iots.TypeOf<typeof QuizSettingOrderC>;

export const foldQuizSettingOrder = adt.foldFromKeys(orderKeys);

const eqQuizSettingOrder: eq.Eq<QuizSettingOrder> = string.Eq;

//--------------------------------------------------------------------------------------------------

export const QuizSettingsC = iots.struct(
  {
    order: QuizSettingOrderC,
  },
  {
    grading: QuizGradingSettings,
  },
);

export type QuizSettings = iots.TypeOf<typeof QuizSettingsC>;

export const defaultQuizSettings: QuizSettings = {
  order: 'manual',
};

export const quizSettingsEq: eq.Eq<QuizSettings> = eq.strict({
  order: eqQuizSettingOrder,
  grading: eq.nullable(eqQuizGradingSettings),
});
